"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import 'polyfill';
// global.Promise = require('es6-promise').Promise;
require("picturefill");
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
// import Hasher from 'hasher';
// import Linker from 'linker';
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
// import '@fancyapps/fancybox';
// import 'fancy-defaults';
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var widget_1 = __importDefault(require("widget"));
var menu_1 = __importDefault(require("menu"));
var top_1 = __importDefault(require("top"));
// import 'accordion';
require("gallery");
var products_1 = require("products");
var scroll_anim_1 = __importDefault(require("scroll-anim"));
// Hasher();
$(function () {
    new menu_1.default();
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sw-Modal'
    });
    $('.c-Gallery').gallery();
    new top_1.default();
    new products_1.Slider();
    new products_1.Gallery();
    new products_1.GradScroll();
    scroll_anim_1.default();
    object_fit_images_1.default('img.sw-ObjectFit', { watchMQ: true });
    var $error = $('span.error');
    if ($error.length) {
        $error.each(function () {
            $(this).prev('.f-Row').each(function () {
                $(this).find('.f-Text, .f-Textarea, .f-Privacy').addClass('-error');
            });
            $(this).prev('.f-Text, .f-Textarea, .f-Privacy').addClass('-error');
        });
        $('.f-ErrorBox').show(0);
    }
    ;
    $('.c-Pagination').find('.-disabled').on('click', function (e) {
        e.preventDefault();
    });
    $(window).trigger('scroll.scrollAnim');
});
$(window).on('load', function () {
    new widget_1.default();
});
